import Services from '../Service'

class AdminAuditoriaService extends Services {
  constructor() {
    super()
    this.resource = 'admin/auditoria'
  }

  async getRegistros(params) {
    return await this.getAPI(this.resource, params)
  }

  async getFiltros() {
    return await this.getAPI(`${this.resource}/filtros`)
  }
}

export default new AdminAuditoriaService()
